import { Icon16ShortcutCommand } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const MacCmdIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        d="M18.5 2C19.4283 2 20.3185 2.36875 20.9749 3.02513C21.6313 3.6815 22 4.57174 22 5.5C22 6.42826 21.6313 7.3185 20.9749 7.97487C20.3185 8.63125 19.4283 9 18.5 9H15V5.5C15 4.57174 15.3687 3.6815 16.0251 3.02513C16.6815 2.36875 17.5717 2 18.5 2Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9H5.5C4.57174 9 3.6815 8.63125 3.02513 7.97487C2.36875 7.3185 2 6.42826 2 5.5C2 4.57174 2.36875 3.6815 3.02513 3.02513C3.6815 2.36875 4.57174 2 5.5 2C6.42826 2 7.3185 2.36875 7.97487 3.02513C8.63125 3.6815 9 4.57174 9 5.5V9Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15H18.5C19.4283 15 20.3185 15.3687 20.9749 16.0251C21.6313 16.6815 22 17.5717 22 18.5C22 19.4283 21.6313 20.3185 20.9749 20.9749C20.3185 21.6313 19.4283 22 18.5 22C17.5717 22 16.6815 21.6313 16.0251 20.9749C15.3687 20.3185 15 19.4283 15 18.5V15Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 22C4.57174 22 3.6815 21.6313 3.02513 20.9749C2.36875 20.3185 2 19.4283 2 18.5C2 17.5717 2.36875 16.6815 3.02513 16.0251C3.6815 15.3687 4.57174 15 5.5 15H9V18.5C9 19.4283 8.63125 20.3185 7.97487 20.9749C7.3185 21.6313 6.42826 22 5.5 22Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9H9V15H15V9Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MacCmdIcon = fplIcon(MacCmdIconLocal, Icon16ShortcutCommand);
